// Short label for a question, used on the "by question" overview bars.
// Prefer the curated short title; if none is set, fall back to a truncated
// question sentence (full text can be shown as a tooltip by the caller).
export const getQuestionLabel = (
    question: { questionTitle: string | null; questionText: string },
    maxLen = 40
): string => {
    if (question.questionTitle && question.questionTitle.trim()) {
        return question.questionTitle.trim();
    }

    const text = question.questionText.trim();
    if (text.length <= maxLen) {
        return text;
    }

    // Cut at maxLen and drop any dangling partial word before adding the ellipsis.
    return `${text.slice(0, maxLen).replace(/\s+\S*$/, '')}…`;
};

export default getQuestionLabel;
